<template>
  <SearchBar
    v-model:value="value.search"
    @update="emits('update')"
  />
  <FoldableContent
    :image="require('@/images/filter_icon.png')"
    title="Filter"
  >
    <EnumerationsPicker
      v-if="orderTypes"
      v-model:selection="value.orderFilter.types"
      title="Types"
      :options="orderTypes"
      @update="emits('update')"
    />
    <EnumerationsPicker
      v-if="orderStatuses"
      v-model:selection="value.orderFilter.statuses"
      title="Statuses"
      :options="orderStatuses"
      @update="emits('update')"
    />
  </FoldableContent>
  <FoldableContent
    :image="require('@/images/order_icon.png')"
    title="Order"
  >
    <Option
      v-if="orderOrders"
      v-model:selection="value.order"
      title="Order"
      :options="orderOrders"
      @update="emits('update')"
    />
  </FoldableContent>
  <Button
    title="Reset"
    :image="require('@/images/reset_icon.png')"
    @click="emits('reset')"
  />
</template>

<script setup lang="ts">
  import SearchBar from "@/components/search_bar.vue"
  import Option from "@/components/inputs/option.vue"
  import EnumerationsPicker from "@/components/selectors/enumerations.vue"
  import FoldableContent from "@/components/foldable_content.vue"
  import Button from "@/components/button.vue"
  import {PropType} from "vue"
  import {OrderInput} from "@/endpoints/rutsolve/gql/generated/types"
  
  defineProps({
    orderOrders: {
      default: null,
      required: false,
      type: Array<string>
    },
    orderStatuses: {
      default: null,
      required: false,
      type: Array<string>
    },
    orderTypes: {
      default: null,
      required: false,
      type: Array<string>
    }
  })
  
  const emits = defineEmits(["reset", "update"])
  const value = defineModel("value", {
    default: null,
    required: true,
    type: Object as PropType<OrderInput>
  })
</script>
